import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export const ModalConfirm = ({ isOpen, toggle, message, onConfirm }) => {
  const isConfirm = !!onConfirm;

  const handleConfirm = () => {
    onConfirm();
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {isConfirm ? "Confirmar acción" : "Ocurrió un error"}
      </ModalHeader>
      <ModalBody>
        <p style={{ margin: 0 }}>{message}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          {isConfirm ? "Cancelar" : "Cerrar"}
        </Button>
        {isConfirm && (
          <Button color="danger" onClick={handleConfirm}>
            Confirmar
          </Button>
        )}
      </ModalFooter>
    </Modal>
  )
};